import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum TailIconVariant {
  DEFAULT = 'default',
}

export interface ITailIconProps extends IConDefaultType {
  variant?: TailIconVariant;
}

function TailIcon({
  color = '#DBE0EA',
  className,
  rotate,
  flip,
  variant = TailIconVariant.DEFAULT,
  style,
}: ITailIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: 9,
        minWidth: 9,
        height: 11,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === TailIconVariant.DEFAULT && (
        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.418092 0H9V11C9 11 8.58293 7.31169 7.11962 5.33201C4.87397 2.29393 0.349361 1.1308 0.163466 1.00412C-0.261427 0.714585 0.418092 0 0.418092 0Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}

export default TailIcon;
